import React from "react"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    Box,
    Button,
    Divider,
    Spacer,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"

import TextLogo from "~components/shared/header/logo"
import IconLogo from "~components/shared/header/icon-logo"
import SidebarContent from "~components/shared/sidebar/sidebar-content"
import { usePageLayout } from "~contexts/page-layout-provider"
import { TEST_IDS } from "~config/constants"

import { SIDEBAR_WIDTHS } from "./use-sidebar-inline-width"
import SidebarVersion from "./sidebar-version"
import { hiddenScrollbarStyles } from "./hidden-scrollbar-styles"

export default function SidebarEmbedded() {
    const { isSidebarOpen, setIsSidebarOpen } = usePageLayout()
    const styles = useStyles({ isSidebarOpen })

    return (
        <Box data-testid={TEST_IDS.SIDEBAR_EMBEDDED} style={styles.container}>
            <Box style={styles.logoCenter}>
                {isSidebarOpen ? (
                    <TextLogo />
                ) : (
                    <IconLogo style={styles.squareLogo} />
                )}
            </Box>
            <Divider />
            <Box style={styles.scrollArea}>
                <SidebarContent isCollapsed={!isSidebarOpen} />
            </Box>
            <Spacer />
            <Box style={styles.collapseSection}>
                <Button
                    style={styles.collapseButton}
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                >
                    <Box style={styles.chevron(isSidebarOpen)}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </Box>
                </Button>
                <Divider />
                <SidebarVersion />
            </Box>
        </Box>
    )
}

function useStyles({ isSidebarOpen }: { isSidebarOpen: boolean }) {
    const colors = useColors()

    return {
        ...componentStyles({
            container: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: isSidebarOpen
                    ? SIDEBAR_WIDTHS.OPEN
                    : SIDEBAR_WIDTHS.CLOSED,
                transition: "width .3s, background-color .2s, display .3s",
                position: "relative",
                borderRightWidth: "1px",
                borderColor: colors.border,
            },
            logoCenter: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minH: "64px",
            },
            scrollArea: {
                overflow: "auto",
                ...hiddenScrollbarStyles,
            },
            collapseSection: {
                display: { base: "none", sm: "initial" },
            },
            collapseButton: {
                width: "100%",
                borderRadius: 0,
            },
            squareLogo: {
                width: "52px",
                height: "52px",
            },
        }),
        chevron: (isOpen: boolean) => ({
            transform: isOpen ? "" : "rotate(-180deg)",
            transition: "transform .3s",
        }),
    }
}
